import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-73c4f0fc")

_pushScopeId("data-v-73c4f0fc")
const _hoisted_1 = { class: "mt-4 mx-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Switch = _resolveComponent("Switch")
  const _component_BoostpackItemFeed = _resolveComponent("BoostpackItemFeed")
  const _component_BoostpackFeed = _resolveComponent("BoostpackFeed")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _withDirectives(_createVNode(_component_Switch, {
        tabs: _ctx.feedTabs,
        onTriggerTab: _ctx.triggerTab
      }, null, 8, ["tabs", "onTriggerTab"]), [
        [_vShow, true]
      ])
    ]),
    (_ctx.currentRoute === '/feed/items')
      ? (_openBlock(), _createBlock(_component_BoostpackItemFeed, { key: 0 }))
      : (_openBlock(), _createBlock(_component_BoostpackFeed, { key: 1 }))
  ]))
})